import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]

  toggle(event) {
    const clicked = event.currentTarget
    this.stepTargets.forEach(step => step.classList.remove("step-active"))
    clicked.classList.add("step-active")
  }
}
